import {
  GET_OUT_RIGHT_CONTINUE_COUPONS_REQUEST,
  GET_OUT_RIGHT_CONTINUE_COUPONS_SUCCESS,
  GET_OUT_RIGHT_CONTINUE_COUPONS_FAILURE,
  RESET_OUT_RIGHT_CONTINUE_PAGINATION
} from 'Store/constants';

const initialState = {
  data: [],
  pagination: {
    pageSize: 10,
    pageIndex: 0,
    isLoadMoreButtonVisible: false
  },
  isFetched: false,
  isLoading: null,
  error: null
};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_OUT_RIGHT_CONTINUE_COUPONS_REQUEST:
      return { ...state, isLoading: true, error: null };

    case GET_OUT_RIGHT_CONTINUE_COUPONS_SUCCESS:

      if (action.sharedCouponId) {
        state.data.map(coupon => {
          if (coupon.couponId === action.sharedCouponId) {
            coupon.isShared = true;
          }
          return coupon;
        });
      }

      return {
        data: [...state.data, ...action.payload],
        pagination: action.pagination,
        isFetched: true,
        isLoading: false,
        error: null
      };

    case GET_OUT_RIGHT_CONTINUE_COUPONS_FAILURE:

      return {
        ...state,
        pagination: initialState.pagination,
        isFetched: true,
        isLoading: false,
        error: action.payload
      };

    case RESET_OUT_RIGHT_CONTINUE_PAGINATION:
      return { ...state, pagination: initialState.pagination, data: [] };

    default:
      return state;
  }
};
